import Home from './components/Home.vue';
import AboutPage from './components/AboutPage.vue';
import TestimonialsPage from './components/TestimonialsPage.vue';
import CoachingPage from './components/CoachingPage.vue';
import BlogPage from './components/BlogPage.vue';
import ContactPage from './components/ContactPage.vue';
import ContactsViewer from './components/ContactsViewer.vue';
import BlogPostOne from './components/BlogPostOne.vue';
import BlogPostTwo from './components/BlogPostTwo.vue';
import BlogHome from './components/BlogHome'
import BlogPost from './components/BlogPost'

export const routes = [
  { path: '', component: Home },
  { path: '/about', component: AboutPage },
  { path: '/testimonials', component: TestimonialsPage },
  { path: '/coaching', component: CoachingPage },
  { path: '/contact', component: ContactPage },
  { path: '/jackies-contact-viewer', component: ContactsViewer },
  { path: '/blog/', name: 'blog-home', component: BlogHome },
  { path: '/blog-page/:slug', name: 'post', component: BlogPost },
  { path: '/blog/1', component: BlogPostOne },
  { path: '/blog/2', component: BlogPostTwo }
];


// WEBPACK FOOTER //
// ./src/routes.js